import { STORE_TILES, type StoreTileId } from '../data/kelirijiDownload';

type StoreTilesProps = {
  tone?: 'light' | 'dark';
  activeId?: StoreTileId | null;
};

const MONOCHROME_STORE_IDS = new Set<StoreTileId>(['ios', 'honor']);

export function StoreTiles({ tone = 'light', activeId = null }: StoreTilesProps) {
  const dark = tone === 'dark';
  const idleLabel = dark ? 'text-[#8A9CB8]' : 'text-muted';
  const activeLabel = dark ? 'text-white' : 'text-primary';
  const activeBg = dark ? 'bg-white/10' : 'bg-[#EAF2FF]/80';
  const hoverIdle = dark
    ? 'hover:bg-white/[0.08] hover:text-[#D5E4F5]'
    : 'hover:bg-[#EAF2FF]/60 hover:text-ink';

  return (
    <div className="w-full">
      <div className="flex w-full items-start justify-between gap-0.5 sm:gap-1">
        {STORE_TILES.map((item) => {
          const matched = item.id === activeId;
          return (
            <a
              key={item.id}
              href={item.href}
              className={`group flex min-w-0 flex-1 flex-col items-center gap-1.5 rounded-xl px-0.5 py-1.5 text-center text-[10px] font-medium leading-tight transition-all duration-200 sm:gap-2 sm:py-2 sm:text-[11px] md:text-xs ${
                matched ? `${activeLabel} ${activeBg}` : `${idleLabel} ${hoverIdle}`
              }`}
            >
              <img
                src={item.logo}
                alt=""
                width={32}
                height={32}
                className={`h-8 w-8 shrink-0 object-contain transition-transform duration-200 group-hover:scale-110 sm:h-9 sm:w-9 ${
                  matched ? 'scale-105' : ''
                } ${dark && MONOCHROME_STORE_IDS.has(item.id) ? 'brightness-0 invert' : ''}`}
              />
              <span className="w-full transition-colors duration-200">{item.label}</span>
            </a>
          );
        })}
      </div>
    </div>
  );
}
